export const CALL_DISPOSITIONS = [
  { value: "no_answer", label: "No answer" },
  { value: "busy", label: "Busy" },
  { value: "rejected", label: "Rejected / declined" },
  { value: "voicemail", label: "Voicemail" },
  { value: "wrong_number", label: "Wrong number" },
  { value: "connected", label: "Connected" },
  { value: "booked", label: "Booked" },
  { value: "callback", label: "Callback" },
  { value: "dnc", label: "DNC" },
  { value: "other", label: "Other" },
]

export const SELECTABLE_CALL_DISPOSITIONS = CALL_DISPOSITIONS.filter(
  (option) => option.value !== "connected"
)

export function getCallDispositionLabel(value) {
  return (
    CALL_DISPOSITIONS.find((option) => option.value === value)?.label || value
  )
}
